__turbopack_context__.v({
  "content": "_1D2ZVW_content",
  "lights": "_1D2ZVW_lights",
  "root": "_1D2ZVW_root",
});
